var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.25V9L15.75 6.75",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9L11.25 6.75",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 13.5C3.375 13.5 3.375 15.5137 3.375 18V19.125C3.375 22.23 3.375 24.75 9 24.75H18C22.5 24.75 23.625 22.23 23.625 19.125V18C23.625 15.5137 23.625 13.5 19.125 13.5C18 13.5 17.685 13.7363 17.1 14.175L15.9525 15.39C14.625 16.8075 12.375 16.8075 11.0363 15.39L9.9 14.175C9.315 13.7363 9 13.5 7.875 13.5Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 13.5019V9.00188C5.625 6.74063 5.625 4.87312 9 4.54688",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 13.5019V9.00188C21.375 6.74063 21.375 4.87312 18 4.54688",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgupload);
export default __webpack_public_path__ + "static/media/imgupload.69e6961b696db1c8b4dfa1fcd51cdef1.svg";
export { ForwardRef as ReactComponent };